import { useQuery } from '@tanstack/react-query';

import { getStripeCustomerPortal } from '@pray/shared/services/studioService/credits';
import logger from '@pray/shared/utils/logger';

type UseStripeCustomerPortalProps = {
  artistId?: string;
};

export function useStripeCustomerPortal({ artistId }: UseStripeCustomerPortalProps) {
  const query = useQuery({
    queryKey: ['stripe-customer-portal', artistId],
    queryFn: async () => {
      // This will be called with the current returnUrl when refetch is triggered
      return null; // Placeholder, actual call happens in openStripeCustomerPortal
    },
    enabled: false, // Don't auto-fetch, only fetch when manually triggered
  });

  const openStripeCustomerPortal = async ({ returnUrl }: { returnUrl?: string } = {}) => {
    try {
      // Make the API call directly since we need dynamic parameters
      const portalUrl = await getStripeCustomerPortal({
        artistId,
        query: returnUrl ? { return_url: returnUrl } : undefined,
      });

      // If we have a portal URL, redirect to it
      if (portalUrl) {
        window.open(portalUrl, '_blank');
      }

      return portalUrl;
    } catch (error) {
      logger.error('Failed to open Stripe customer portal:', error);
      throw error;
    }
  };

  return {
    openStripeCustomerPortal,
    isLoading: query.isLoading,
    error: query.error,
    data: query.data,
  };
}
